import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const SelectEmptyOption = /*#__PURE__*/ memo((param)=>{
    let { noOptionsText } = param;
    return /*#__PURE__*/ _jsx("li", {
        className: "flex w-full items-center justify-center",
        children: /*#__PURE__*/ _jsx("div", {
            className: "text-12 font-medium text-grey-10",
            children: noOptionsText || "No options"
        })
    });
});
SelectEmptyOption.displayName = "SelectEmptyOption";
